import React from "react";
import moment from "moment";
import DateSelector from "../Reports/DateSelector";
import ExportButton from "../Reports/ExportButton";
import DataTable from "../DataTable/DataTable";
import DataTableConfiguration from "../DataTable/DataTableConfiguration";
import ReportHelper from "./ReportHelper";

export default class PopularCoursesReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFormat: "YYYY-MM-DD",
      dataTableRenderCount: 0,
      loading: false,
      dateRange: "30",
      startDate: moment().subtract(30, "days"),
      endDate: moment(),
      pageLength: 10,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeDates = this.onChangeDates.bind(this);
    this.onExport = this.onExport.bind(this);
  }

  render() {
    var self = this;

    //console.log('PopularCoursesReport', this.props, this.state.dataTableRenderCount);

    return (
      <div className="Report PopularCoursesReport">
        <DateSelector
          dateRange={this.state.dateRange}
          dateFormat={this.state.dateFormat}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.onChange}
          onChangeDates={this.onChangeDates}
        />
        <ExportButton onExport={this.onExport} />
        <DataTable
          config={DataTableConfiguration["exports"]}
          dataTableRenderCount={this.state.dataTableRenderCount}
          endpoint={
            this.props.export_datatable_endpoint +
            "?report=" +
            this.props.report
          }
        />
        {this.state.loading ? (
          <div className="loadingOverlay">
            <div className="spinner"></div>
          </div>
        ) : null}
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    var self = this;
    if (prevState.dateRange !== this.state.dateRange) {
      var dateRange = parseInt(this.state.dateRange);
      if (isNaN(dateRange)) {
        // custom date range
      } else {
        this.setState({
          startDate: moment().subtract(dateRange, "days"),
          endDate: moment(),
        });
      }
    }
  }

  /**
   * Change handlers
   */

  onChange(event) {
    if (event && event.target && event.target.name) {
      this.setState(
        Object.assign({}, this.state, {
          [event.target.name]: event.target.value,
        })
      );
    }
  }

  onChangeDates(startDate, endDate, validate) {
    if (validate === true) {
      if (
        !startDate ||
        !endDate ||
        !startDate.isValid() ||
        !endDate.isValid()
      ) {
        endDate = startDate.clone().add(1, "days");
      }
    }

    let dateRange = ReportHelper.getDateRange(startDate, endDate); //endDate.diff(startDate, "days")

    this.setState(
      Object.assign({}, this.state, {
        startDate: startDate,
        endDate: endDate,
        dateRange: dateRange, //dateRange === 30 || dateRange === 60 || dateRange === 90 ? dateRange : 'custom'
      })
    );
  }

  onExport(e) {
    var self = this;

    e.preventDefault();
    e.stopPropagation();

    $.ajax({
      type: "POST",
      url: this.props.export_endpoint,
      data: {
        report: this.props.report,
        start_date: self.state.startDate.format(self.state.dateFormat),
        end_date: self.state.endDate.format(self.state.dateFormat),
      },
    }).done(function (data) {
      if (data.success) {
        self.setState(
          { dataTableRenderCount: self.state.dataTableRenderCount + 1 },
          () => {
            alert(I18n.t("admin.export_scheduled_successfully"));
          }
        );
      } else {
        alert(
          I18n.t(
            typeof data.error === "string"
              ? data.error
              : "admin.problem_exporting"
          )
        );
      }
    });
  }
}
